export default import.meta.ROLLUP_FILE_URL_9D7qZZ0x;